
<style scoped>
.btn-danger {
  border-color: #ff5855;
  background-color: #ff5855;
}

.resend {
  border-color: #ff5855;
  background-color: #fff;
  color: #ff5855;
}
</style>

<template>
  <div>
    <base-header type class="rsgradient pb-3 pb-1 pt-3 pt-md-5"></base-header>
    <b-card style="margin: 20px">
      <b-card-header header-tag="header" class="p-1" role="tab">Modificación de mail</b-card-header>
      <b-card-body>
        <div class="row justify-content-center email-validation-form" v-if="cargado">
          <div class="col-lg-5 col-md-7">
            <div class="card bg-secondary shadow border-0" style="border-radius:10px;">
              <div
                class="card-body px-lg-5 py-lg-5 shadow"
                style="border:2px solid #d0d0d0;border-radius:10px;"
              >
                <div class="text-center">
                  <div class="row">
                    <div class="col-md-12">
                      <img
                        src="@/assets/verifymail.png"
                        class="img-fluid mb-2"
                        style="max-width:160px;"
                      />
                    </div>
                  </div>
                  <div>
                    <div class="row">
                      <div class="col-md-12 text-center">
                        <span>Ingresá la nueva dirección de e-mail.</span>
                      </div>
                    </div>
                    <div class="row mt-2">
                      <div class="col-md-12">
                        <base-input
                          addon-left-icon="ni ni-email-83"
                          placeholder="Email"
                          class="input-group-alternative mb-3"
                          v-model="email"
                        ></base-input>
                      </div>
                    </div>
                    <div>
                      <div class="text-center col-md-12">
                        <button @click="btnAceptarClick" class="btn btn-danger btn-lg">Aceptar</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import axiosHelpers from "@/helpers/axiosHelpers";
import notificationHelpers from "@/helpers/notificationHelpers";
import PincodeInput from "vue-pincode-input";
import PinValidation from "@/views/Pin/PinValidation";

export default {
  name: "EmailModification",
  components: {
    "pincode-input": PincodeInput,
    "pin-validation": PinValidation
  },
  props: {
    url: {
      type: String,
      default: "/dashboard",
      description: "Url para realizar push luego de validar"
    },
    accountID: {
      type: Number,
      default: 0,
      description:
        "Id de cuenta del mail"
    }
  },
  data() {
    return {
      email: "",
      cargado: false
    };
  },
  methods: {
    GetAccountMail() {
      let context = this;

      axiosHelpers.axiosGet(
        "Account/GetAccountMail",
        {
          AccountID: context.accountID
        },
        context,
        function(data) {
          context.cargado = true;
          if (data.ResponseVM.Email != null && data.ResponseVM.Email != "") {
            context.email = data.ResponseVM.Email;
          }
        }
      );
    },
    btnAceptarClick() {
      let context = this;

      axiosHelpers.axiosPost(
        "Account/SaveAccountMail",
        { AccountID: context.accountID, Mail: context.email },
        context,
        function(data) {
          if (data.ResponseVM.Success) {
            notificationHelpers.showSuccess(
              "Modificación de Email",
              "Se ha modificado el Email correctamente",
              context
            );
            context.$router.push({
              name: context.url.replace(/\//g, ''),
              params: { EntityIDProp: context.accountID }
            });
          }
        }
      );
    }
  },
  beforeMount() {
    this.GetAccountMail();
  }
};
</script>
